import { useContext } from 'react';

import { TemplateParamsContext } from 'providers';

export const useTemplateParams = () => useContext(TemplateParamsContext);

export default useTemplateParams;
